import { render, staticRenderFns } from "./RtpcrProcessing.vue?vue&type=template&id=95b3e25a&scoped=true&"
import script from "./RtpcrProcessing.vue?vue&type=script&lang=js&"
export * from "./RtpcrProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b3e25a",
  null
  
)

export default component.exports